export enum AvatarShape {
  Circle = 'circle',
  Square = 'square'
}
